import { IAllFirmList } from './../types/FirmType'
import http from '../core/http-common'

class FirmService {
  getAllFirmList() {
    return http.get<IAllFirmList[]>(`/Firm/GetAllFirmList`)
  }
}
export default new FirmService()
